import {
    Center,
    Stack,
    Title,
    Text,
    Grid,
    Box,
    Button,
    Group,
    Paper
} from '@mantine/core';
import { Link } from 'react-router-dom';
import SignInForm from 'src/components/auth/SignInForm';
import { BookwellLogo } from 'src/components/ui/logos/BookwellLogo';

export default function SignIn() {

    return (
        <Paper shadow="md">
            <Grid gutter={0}>

                {/* Right Side - Visual */}
                <Grid.Col span={{ base: 12, md: 6, lg: 7 }} visibleFrom="md">
                    <Box
                        h="100%"
                        style={{
                            backgroundImage: [
                                'radial-gradient(900px circle at 72% 38%, rgba(73, 164, 255, 0.26) 0%, transparent 58%)',
                                'radial-gradient(760px circle at 22% 72%, rgba(24, 233, 199, 0.18) 0%, transparent 60%)',
                                'radial-gradient(680px circle at 55% 108%, rgba(10, 112, 255, 0.14) 0%, transparent 66%)',
                                'radial-gradient(520px circle at 88% 16%, rgba(141, 184, 255, 0.16) 0%, transparent 62%)',
                                'linear-gradient(150deg, #02050d 0%, #06142a 44%, #0b2040 72%, #0f2b4f 100%)',
                            ].join(', '),
                        }}
                    >
                        <Center h="100%" p="xl">
                            <Stack align="center" gap="xl" maw={520} style={{ color: 'white', textAlign: 'center' }}>
                                <Title order={1} size={52} fw={900} style={{ lineHeight: 1.05 }}>
                                    Book smarter. Work smoother.
                                </Title>
                                <Text size="lg" style={{ opacity: 0.92, maxWidth: 480 }}>
                                    Manage bookings, availability, and client details in one place—so your day runs itself.
                                </Text>
                                <Button
                                    component={Link}
                                    to="/sign-up"
                                    variant="outline"
                                    color="white"
                                    size="lg"
                                    radius="xl"
                                    w={220}
                                    styles={{ root: { borderWidth: 2, backdropFilter: 'blur(8px)' } }}
                                >
                                    Register
                                </Button>
                            </Stack>
                        </Center>
                    </Box>
                </Grid.Col>

                {/* Left Side - Form */}
                <Grid.Col span={{ base: 12, md: 6, lg: 5 }} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Box bg="white">
                        <Center h="100%" p={{ base: 'md', md: 'xl' }}>
                            <Stack w="100%" maw={400} gap="xl">

                                <Group>
                                    <BookwellLogo height="100" />
                                </Group>

                                <Stack gap="xs">
                                    <Title order={2} size="h1" fw={900}>Sign In</Title>
                                    <Text c="dimmed" size="sm">
                                        Welcome back! Please enter your details.
                                    </Text>
                                </Stack>

                                <SignInForm />

                                <Center>
                                    <Text size="xs" c="dimmed">
                                        © 2026 Rockwell. All rights reserved.
                                    </Text>
                                </Center>

                            </Stack>
                        </Center>
                    </Box>
                </Grid.Col>


            </Grid>
        </Paper>
    );
}
